import {ApiResource} from 'common/util/model-resource/api-resource';

import {EventDefinition} from '../queries/app-api/data-definitions-types';
import {eventDefinitionsClient, update} from '../queries/query-api/event-definitions-client';

export class EventDefinitionsResource extends ApiResource<EventDefinition> {
  apiClient = eventDefinitionsClient;

  async patch(eventDefinition: Partial<EventDefinition>): Promise<void> {
    const updateResponse = await update(eventDefinition);
    this.update({[eventDefinition.id ?? 0]: updateResponse});
  }
}
